import { faChartBar, faIndustry } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../../Context/User";
import { ACESSOS } from "../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../Validations/UsuarioTela";

export function SubNavRelatoriosHelpDesk() {
    const { UserInfor } = useUserInfor();

    const emccampMode = "E830AEF3-49DF-4DC1-8560-DC78EE448F01";
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;

    return (
        <>
            {mostrarNavDeTela(
                ACESSOS.HELPDESK.TELAS.WHATSAPP_BI.ID_TELA,
                UserInfor.TELAS
            ) && (
                <li className="menu-item">
                    <NavLink
                        to={ACESSOS.HELPDESK.TELAS.WHATSAPP_BI.DS_PATH}
                        exact
                        activeClassName="active"
                        className="menu-link"
                    >
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faIndustry} />
                        </span>
                        <span className="menu-text">Relatório BI WhatsApp</span>
                    </NavLink>
                </li>
            )}
            {mostrarNavDeTela(
                ACESSOS.HELPDESK.TELAS.WHATSAPP_BOT_BI.ID_TELA,
                UserInfor.TELAS
            ) &&
                emccampMode === ID_ORGANIZACAO && (
                    <li className="menu-item">
                        <NavLink
                            to={ACESSOS.HELPDESK.TELAS.WHATSAPP_BOT_BI.DS_PATH}
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faChartBar} />
                            </span>
                            <span className="menu-text">Power BI Bot</span>
                        </NavLink>
                    </li>
                )}
        </>
    );
}
